<template>
  <div :style="indent">
    <template v-if="isMethodGroup">
      <fieldset>
        <div v-for="(field, index) in method" :key="'verification-field-' + depth.toString() + '-' + index.toString()">
          <div v-if="index > 0" class="field-or-separator">or</div>
          <VerificationField :method="field" :value="fields" :placeholders="placeholders"></VerificationField>
        </div>
      </fieldset>
    </template>
    <fieldset v-else>
      <div class="fields mt-0 mob-verfi">
        <div v-show="isFirstNameRequired" class="pt-0 mb-4 first-name">
          <div class="customer-match-formgroup">
            <label for="first_name" class="text-capitalize" v-if="isIE">First Name</label>
            <b-form-group label-for="first_name">
              <div data-for="first_name" class="placeholder-label">First Name</div>
              <b-form-input id="first_name" type="text" :value="fields.first_name"
                            :placeholder="placeholders.first_name" @input="updateData('first_name', $event)"
                            class="customer form-input-height" :required="isFirstNameRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-show="isLastNameRequired" class="pt-0 mb-4 second-name">
          <div class="customer-match-formgroup">
            <label for="last_name" class="text-capitalize" v-if="isIE">Last Name</label>
            <b-form-group label-for="last_name">
              <div data-for="last_name" class="placeholder-label">Last Name</div>
              <b-form-input id="last_name" type="text" :value="fields.last_name" :placeholder="placeholders.last_name"
                            @input="updateData('last_name', $event)" class="customer form-input-height"
                            :required="isLastNameRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isFullAddressRequired">
          <div class="customer-match-formgroup">
            <label for="address" class="text-capitalize" v-if="isIE">Address</label>
            <b-form-group label-for="address">
              <div data-for="address" class="placeholder-label">Address</div>
              <b-form-input id="address" type="text" :value="fields.address" :placeholder="placeholders.address"
                            @input="updateData('address', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="city" class="text-capitalize" v-if="isIE">City</label>
            <b-form-group label-for="city">
              <div data-for="city" class="placeholder-label">City</div>
              <b-form-input id="city" type="text" :value="fields.city" :placeholder="placeholders.city"
                            @input="updateData('city', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="country" v-if="isIE">Country</label>
            <b-form-group label="" label-for="country">
              <div data-for="country" class="placeholder-label">Country</div>
              <b-form-select id="country" v-model="fields.country" :options="getCountries" placeholder="Country" @change="updateData('country', $event)" class="customer select"></b-form-select>
            </b-form-group>
            <label for="state" class="text-capitalize" v-if="isIE">State</label>
            <b-form-group label-for="state">
              <div data-for="state" class="placeholder-label">State</div>
              <b-form-select v-if="isUsOrCA()" id="state" v-model="fields.state" :options="getStates()"
                             :placeholder="placeholders.state" @input="updateData('state', $event)"
                             class="customer select form-input-height"></b-form-select>
              <b-form-input v-if="!isUsOrCA()" id="state" type="text" :value="fields.state" :placeholder="placeholders.state"
                            @input="updateData('state', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="zip" class="text-capitalize" v-if="isIE">Zip</label>
            <b-form-group label-for="zip">
              <div data-for="zip" class="placeholder-label">Zip</div>
              <b-form-input id="zip" type="text" :formatter="zipFormat" :value="fields.zip" :placeholder="placeholders.zip"
                            @input="updateData('zip', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <template v-else>
          <div v-show="isStreetRequired">
            <div class="customer-match-formgroup">
              <label for="address" class="text-capitalize" v-if="isIE">Address</label>
              <b-form-group label-for="address">
                <div data-for="address" class="placeholder-label">Address</div>
                <b-form-input id="address" type="text" :title="getStreetTitle" :value="fields.address"
                              :placeholder="placeholders.address" @input="updateData('address', $event)"
                              class="customer" :required="isStreetRequired"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div v-show="isZipRequired">
            <div class="customer-match-formgroup">
              <label for="zip" class="text-capitalize" v-if="isIE">Zip</label>
              <b-form-group label-for="zip">
                <div data-for="zip" class="placeholder-label">Zip</div>
                <b-form-input id="zip" type="text" :title="getZipTitle" :value="fields.zip"
                              :placeholder="placeholders.zip" @input="updateData('zip', $event)"
                              class="customer" :required="isZipRequired"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </template>
        <div v-show="isEmailRequired">
          <div class="customer-match-formgroup">
            <label for="email" class="text-capitalize" v-if="isIE">Email</label>
            <b-form-group label-for="email">
              <div data-for="email" class="placeholder-label">Email</div>
              <b-form-input id="email" type="email" :value="fields.email" :placeholder="placeholders.email"
                            @input="updateData('email', $event)" class="customer"
              :required="isEmailRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-show="isPhoneRequired">
          <div class="customer-match-formgroup">
            <label for="phone" class="text-capitalize" v-if="isIE">Phone</label>
            <b-form-group label-for="phone">
              <div data-for="phone" class="placeholder-label">Phone</div>
              <b-form-input id="phone" type="tel" :value="fields.phone" :placeholder="placeholders.phone"
                            @input="updateData('phone', $event)" class="customer"
              :required="isPhoneRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {Countries} from '@/constants'
import {formatZipField, getCountryStates, isCountryUSOrCA} from '@/utils'

const VerificationMethod = Object.freeze({
  FullName: 1,
  LastName: 2,
  Street: 3,
  Zip: 4,
  Address: 5,
  BillingStreet: 6,
  BillingZip: 7,
  BillingAddress: 8,
  Phone: 1000,
  PartialPhone: 1001,
  Email: 1002,
  PartialEmail: 1003
})

export default {
  name: 'VerificationField',
  props: {
    method: [Number, Array],
    depth: {
      type: Number,
      default: function() {
        return 0
      }
    },
    value: {
      type: Object,
      default: function() {
        return {
          first_name: null,
          last_name: null,
          address: null,
          city: null,
          state: null,
          zip: null,
          phone: null,
          email: null,
          country: 'US'
        }
      }
    },
    placeholders: Object
  },
  data: function() {
    return {
      fields: Object.assign({}, this.value)
    }
  },
  computed: {
    getCountries() {
      return [{value: null, text: 'Country'}, ...Countries]
    },
    isMethodGroup: function() {
      return this.method && typeof this.method === 'object'
    },
    isFirstNameRequired: function() {
      return this.method === VerificationMethod.FullName
    },
    isLastNameRequired: function() {
      return this.method === VerificationMethod.LastName || this.method === VerificationMethod.FullName
    },
    isStreetRequired: function() {
      return this.method === VerificationMethod.BillingStreet || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.Street || this.method === VerificationMethod.Address
    },
    isFullAddressRequired: function() {
      return this.method === VerificationMethod.BillingAddress || this.method === VerificationMethod.Address
    },
    isZipRequired: function() {
      return this.method === VerificationMethod.BillingZip || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.Zip || this.method === VerificationMethod.Address
    },
    isBillingRequired: function() {
      return this.method === VerificationMethod.BillingZip || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.BillingStreet
    },
    isEmailRequired: function() {
      return this.method === VerificationMethod.Email || this.method === VerificationMethod.PartialEmail
    },
    isPhoneRequired: function() {
      return this.method === VerificationMethod.Phone || this.method === VerificationMethod.PartialPhone
    },
    getStreetLabel: function() {
      return this.isBillingRequired ? 'Billing Street:' : 'Street:'
    },
    getStreetTitle: function() {
      return this.isBillingRequired ? 'House number and street of your billing address'
        : 'House number and street of your either your billing or shipping address'
    },
    getZipLabel: function() {
      return this.isBillingRequired ? 'Billing Zip/Postal Code:' : 'Zip/Postal Code:'
    },
    getZipTitle: function() {
      return this.isBillingRequired ? 'Zip/Postal code of your billing address'
        : 'Zip/Postal code of your either your billing or shipping address'
    },
    indent: function() {
      return { transform: `translate(${this.depth * 50}px)` }
    },
    ...mapState(['isIE', 'campaign'])
  },
  methods: {
    updateData: function(field, val) {
      this.fields[field] = val
      this.$parent.updateData(field, val)

      if (field === 'country') {
        this.fields.state = ''
        this.fields.zip = ''
      }
    },
    getStates() {
      return getCountryStates(this.fields.country, this.campaign.blacklisted_states)
    },
    isUsOrCA() {
      return isCountryUSOrCA(this.fields.country)
    },
    zipFormat(value) {
      return formatZipField(value, this.fields.country)
    }
  }
}
</script>

<style scoped>

</style>
